/** Materialize OpenLaws subsection labels before their formatting classes are sanitized away. */
export function normalizeLrrLists(fragment: DocumentFragment): void {
  for (const list of fragment.querySelectorAll('ol')) {
    const format = [...list.classList].find(
      (name) => name === 'use-pincite-display' || /^(parens-)?(decimal|lower-alpha|upper-alpha|lower-roman|upper-roman)$/.test(name)
    )
    if (!format) continue

    const items = [...list.children]
    const markers = items.map((item) => [...item.querySelectorAll('span.pincite-display')].find((span) => span.closest('li') === item))
    // Only replace lists whose own items all have explicit labels; a nested label cannot stand in for its parent.
    if (!items.length || items.some((item, index) => item.tagName !== 'LI' || !markers[index]?.textContent?.trim())) continue

    for (const [index, item] of items.entries()) {
      const marker = markers[index]!
      const label = marker.textContent!.trim()
      marker.textContent = format === 'use-pincite-display' || !/^[a-zA-Z0-9]+$/.test(label) ? label : format.startsWith('parens-') ? `(${label})` : `${label}.`

      // Plain blocks keep literal legal labels in both the browser and DOCX converters, without an automatic counter.
      const block = document.createElement('div')
      block.setAttribute('data-lrr-list-item', '')
      block.append(...item.childNodes)
      item.replaceWith(block)
    }

    const container = document.createElement('div')
    container.setAttribute('data-lrr-list', '')
    container.append(...list.childNodes)
    list.replaceWith(container)
  }
}
